import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../../Assets/icons/download.svg';
import searchIcon from './../../../../../../Assets/icons/searchicon.svg';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg'; 
import './index.scss';
import ListFilters from '../../../OnBoardManagement/ListFilters';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API';
const BusinessPartnerList = () => {
  const [businessPartners, setBusinessPartners] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ city, setCity ] = useState([])
  const [ filters, setFilters ] = useState({})
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchBusinessPartners();
  }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchBusinessPartners(10, newPage);
  };

  useEffect(() => {
  fetchCity();
  fetchBusinessPartnersFilter()
  },[])

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealercity",{
        business_partner_id: 1,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data.data; // Access the data from the response object
      const cityOptions = data.map(city => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };


  const fetchBusinessPartnersFilter = async (filterData) => {
    try {
      const response = await axiosInstance.post('/businesspartner/list', {
        orderBy: 'onboard_id desc',
        startDate: filterData.fromDate,
        endDate: filterData.toDate,
        city_id: filterData.city
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      setBusinessPartners(formattedData); 
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };


  const fetchBusinessPartners = async ( page = 0, pageSize = 10) => {
    const allfilteredData = filters
    try {
      const response = await axiosInstance.post('/businesspartner/list', {
        orderBy: 'onboard_id desc',
        page,
        pageSize,
        startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
          endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
          city_id: allfilteredData?.city? allfilteredData?.city :null,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));
      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setBusinessPartners(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map(header => keyMapping[header]);
    const csvRows = data.map(item => {
      return headers.map(header => {
        const key = keyMapping[header];
        return item[key];
      }).join(',');
    });
    const csvContent = [
      csvHeaders.join(','),
      ...csvRows
    ].join('\n');
    return csvContent;
  };

  const handleDownloadClick = () => {
    const csvContent = formatDataForDownload(businessPartners, BUSINESS_PARTNER_TABLE_HEADERS, BUSINESS_PARTNER_KEY_MAPPING);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'business_partner_data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate('/admin/manage-dealer/business-partner/add-business-partner', { state: { rowData } });
  };

  const filteredBusinessPartners = businessPartners?.filter((item) =>
    item.bp_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Table headers
  const BUSINESS_PARTNER_TABLE_HEADERS = [
    // "Sr. No.",
    // "Business Partner ID",
    "Business Partner",
    "Email",
    "MAX Hierarchy Level",
    "Status",
    "Actions"
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    // "Sr. No.": "Sr No.",
    // "Business Partner ID": "onboard_id",
    "Business Partner": "bp_name",
    "Email": "email_id",
    "MAX Hierarchy Level":"max_hierarchy_level",
    "Status": "status",
    "Actions": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const clearFilter = () => {
    setFilters({});
    fetchBusinessPartners();
  };

  useEffect(() => {
    fetchBusinessPartners();
  }, [filters]);

  const handleSearch = (filteredData) => {
    setFilters(filteredData);
  };

  return (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Business Partner Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2' style={{visibility:"hidden"}}>
          <div className='totalvalues'>
            <h5>50</h5>
            <h6>All Business Partners</h6>
          </div>
          <div className='totalvalues'>
            <h5>30</h5>
            <h6>Active Business Partners</h6>
          </div>
          <div className='totalvalues'>
            <h5>20</h5>
            <h6>Inactive Business Partners</h6>
          </div> 
          <div>
            <button style={{visibility:"hidden"}} className='addcustomerbutton' onClick={() => navigate('/admin/manage-dealer/business-partner/add-business-partner')}>
              Add Business Partner
            </button>
          </div>
        </div>
      </div>

      <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} />

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Business Partner List</h5>
            <div className="searchinput-wrapper">
              <input
                type='text'
                className='searchinput'
                placeholder='Search By Name'
                value={searchTerm}
                onChange={handleSearchInputChange}
              />
              <img src={searchIcon} alt="Search" className="searchinput-icon" />
            </div>
          </div>
          {/* <div className='downloadiconwrapper'>
            <h6 className='downloadTitle'>Download</h6>
            <img src={downloadIcon} alt='download' onClick={handleDownloadClick} style={{ cursor: 'pointer' }} />
          </div> */}
        </div>

        <CustomTable 
          data={filteredBusinessPartners} 
          headers={BUSINESS_PARTNER_TABLE_HEADERS} 
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING} 
          onEdit={handleEdit}  // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          totalRecords={totalRecords} 
        />
      </div>
    </div>
  );
};

export default BusinessPartnerList;
